// extracted by mini-css-extract-plugin
module.exports = {"logoNavigation":"_3WfK9F7DJrjrukLGGPp9jb","logoNavigationHeaderHidden":"_32k8CkYUR3p5sov6ORjR1t","logoWithText":"_798pVNNZGVbIkI93Il2N-","logoNoText":"_20_EuOVijxUux8ajP7JZxy"};